import type { SlotAwareField } from '@cli-types/core-engine/schema-reader.js'
import { isRecord } from '@cli-utils/shared.js'
import { walkSlot } from './walk-slot.js'

export function collectSlotAreaErrors(value: unknown, path: string, errors: string[]): void {
  if (!isRecord(value)) {
    errors.push(`${path} must be an object with a "fields" array.`)
    return
  }

  const fields = value.fields
  if (!Array.isArray(fields)) {
    errors.push(`${path}.fields must be an array.`)
    return
  }

  for (const field of fields as SlotAwareField[]) {
    walkSlot(field, `${path}.fields.${field.name ?? 'unnamed'}`, errors)
  }
}
